import React, { useEffect } from 'react';
import ExamCaseStudyPage from '../../features/specialty/editorial/ExamCaseStudyPage';

export default function ExamCaseStudyRoute() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ExamCaseStudyPage />;
}
